import React from 'react';
import { Edit, SimpleForm, TextInput } from 'react-admin';

const FarmTitle = ({ record }) => {
  return <span>Farm {record ? `"${record.name}"` : ''}</span>;
};

export default (props) => (
  <Edit title={<FarmTitle />} {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <TextInput
        source="identifier"
        helperText="Devine literal segmentul de farm din topicul MQTT (italscada/v1/<identifier>/<turbina>/...) - scurt, unic, fără slash-uri."
      />
    </SimpleForm>
  </Edit>
);
